import * as Sentry from '@sentry/nextjs';

const node = typeof window === 'undefined';
export function logError(error: any, context?: any) {
  if (!node) {
    Sentry.captureException(error, context);
  }
}
